<template>
    <v-sheet style="height:100%;">
        <v-app-bar
            app
            fixed
            elevate-on-scroll
            style="border-bottom:1px solid #ddd; padding:0px; "
            elevation="0"
        >
            <v-btn @click="$router.back()" icon text dark>
                <v-icon color="black">arrow_back</v-icon>
            </v-btn>

            <v-toolbar-title>EDITAR PERFIL</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <template v-if="$vuetify.breakpoint.smAndUp">
                    <v-btn @click="salvar_info()" text color="primary">
                        <v-icon>save</v-icon>&nbsp; Salvar
                    </v-btn>
                </template>
                <template v-if="!$vuetify.breakpoint.smAndUp">
                    <v-btn @click="salvar_info()" text color="primary">
                        <v-icon>save</v-icon>&nbsp; Salvar
                    </v-btn>
                </template>
            </v-toolbar-items>
        </v-app-bar>

        <v-layout style="height:100%; width:100%;">
            <v-flex xs12 md12 >
                <v-card elevation="0" style="height:100%!important" width="100%" class="mt-0">
                    <v-container grid-list-xl fluid>
                        <v-tabs color="#1b5e20" v-model="opened_tab" vertical>
                            <v-tab class="text-left">
                                <v-icon left>mdi-account</v-icon>Pessoal
                            </v-tab>
                            <v-tab>
                                <v-icon left>people</v-icon>Artistíco
                            </v-tab>
                            <v-tab>
                                <v-icon left>perm_contact_calendar</v-icon>Compositor
                            </v-tab>
                            <!-- <v-tab>
                                <v-icon left>money</v-icon>DADOS BANCÁRIOS
                            </v-tab> -->
                            <v-tab>
                                <v-icon left>lock</v-icon>Trocar Senha
                            </v-tab>

                            <v-tab-item>
                                <!--v-divider color="#fafafa"></v-divider-->
                                <v-card elevation="0">
                                    <v-card-title style="color:#000">Informações Pessoais</v-card-title>

                                    <v-card-text>
                                        <v-layout wrap>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Primeiro Nome"
                                                    name="pessoal_nome"
                                                    type="text"
                                                    v-model="person.name"
                                                    hint="Nome utilizado em seus documentos."
                                                    v-validate="'required'"
                                                    data-vv-name="first_name"
                                                    :error-messages="errors.collect('first_name')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Sobrenome"
                                                    name="pessoal_sobrenome"
                                                    type="text"
                                                    v-model="person.lastname"
                                                    hint="Sobrenome utlizado em seus documentos."
                                                    v-validate="'required'"
                                                    data-vv-name="last_name"
                                                    :error-messages="errors.collect('last_name')"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md4>
                                                <v-text-field
                                                    label="CPF"
                                                    name="pessoal_cpf"
                                                    type="text"
                                                    v-model="person.cpf"
                                                    hint="Esse campo é necessário para garantir que você receba o pagamentos corretamente."
                                                    v-validate="'required|cpfcheck'"
                                                    data-vv-name="cpf"
                                                    :error-messages="errors.collect('cpf')"
                                                    v-mask="$globalformmasks.cpf"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md4>
                                                <v-menu
                                                    ref="menu"
                                                    v-model="menu"
                                                    :close-on-content-click="false"
                                                    transition="scale-transition"
                                                    offset-y
                                                    full-width
                                                    min-width="290px"
                                                >
                                                    <template v-slot:activator="{ on }">
                                                        <v-text-field
                                                            v-model="formated_date"
                                                            label="Data de nascimento"
                                                            readonly
                                                            v-on="on"
                                                            @keypress="data_nascimento_focado"
                                                            v-validate="'required'"
                                                            data-vv-name="dob"
                                                            :error-messages="errors.collect('dob')"
                                                            ref="data_nascimento"
                                                        ></v-text-field>
                                                    </template>
                                                    <v-date-picker
                                                        locale="pt-br"
                                                        ref="picker"
                                                        v-model="date"
                                                        :max="new Date().toISOString().substr(0, 10)"
                                                        min="1930-01-01"
                                                        @change="saveDate"
                                                    ></v-date-picker>
                                                </v-menu>
                                            </v-flex>

                                            <v-flex xs12 md4>
                                                <v-text-field
                                                    label="Celular"
                                                    name="pessoal_cellphone"
                                                    type="text"
                                                    v-model="person.cellphone"
                                                    hint="Utilize o seu número de celular ou um no qual conseguimos contato direto."
                                                    v-validate="'required'"
                                                    data-vv-name="cellphone"
                                                    :error-messages="errors.collect('cellphone')"
                                                    v-mask="$globalformmasks.cellphone"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-divider></v-divider>
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-card-title
                                                    style="color:#000"
                                                >Endereço residencial</v-card-title>
                                            </v-flex>

                                            <v-flex xs12 md2>
                                                <v-text-field
                                                    label="CEP"
                                                    name="address_zipcode"
                                                    type="text"
                                                    v-model="person.address_zipcode"
                                                    hint="CEP da sua residência"
                                                    v-validate="'required'"
                                                    data-vv-name="address_zipcode"
                                                    :error-messages="errors.collect('address_zipcode')"
                                                    v-mask="'#####-###'"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md5>
                                                <v-text-field
                                                    label="Endereço"
                                                    name="address_street"
                                                    type="text"
                                                    v-model="person.address_street"
                                                    hint="Endereço da sua residência"
                                                    v-validate="'required'"
                                                    data-vv-name="address_street"
                                                    :error-messages="errors.collect('address_street')"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md2>
                                                <v-text-field
                                                    label="Número"
                                                    name="address_number"
                                                    type="text"
                                                    v-model="person.address_number"
                                                    hint="Número da sua residência"
                                                    data-vv-name="address_number"
                                                    :error-messages="errors.collect('address_number')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md3>
                                                <v-text-field
                                                    label="Complemento"
                                                    name="address_extra"
                                                    type="text"
                                                    v-model="person.address_extra"
                                                    hint="Apartamento/Bloco/Casa/Vila"
                                                    data-vv-name="address_extra"
                                                    :error-messages="errors.collect('address_extra')"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md3>
                                                <v-text-field
                                                    label="Bairro"
                                                    name="address_neighborhood"
                                                    type="text"
                                                    v-model="person.address_neighborhood"
                                                    hint="Bairro da sua residência"
                                                    v-validate="'required'"
                                                    data-vv-name="address_neighborhood"
                                                    :error-messages="errors.collect('address_neighborhood')"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md4>
                                                <v-text-field
                                                    label="Cidade"
                                                    name="address_city"
                                                    type="text"
                                                    v-model="person.address_city"
                                                    hint="Cidade da sua residência"
                                                    v-validate="'required'"
                                                    data-vv-name="address_city"
                                                    :error-messages="errors.collect('address_city')"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md4>
                                                <v-select
                                                    v-model="person.address_state"
                                                    :items="estados_items"
                                                    label="Estado"
                                                    hint="Estado da sua residência"
                                                    item-value="slug"
                                                    item-text="name"
                                                    v-validate="'required'"
                                                    data-vv-name="address_state"
                                                    :error-messages="errors.collect('address_state')"
                                                    :return-object="false"
                                                ></v-select>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card elevation="0">
                                    <v-card-title style="color:#000">Informações artistícas</v-card-title>
                                    <v-card-text>
                                        <v-layout wrap>
                                            <v-flex xs12 md4>
                                                <v-text-field
                                                    label="Nome artistico"
                                                    name="artistic_name"
                                                    type="text"
                                                    v-model="artists[0].name"
                                                    hint="Nome pelo qual você é ou gostaria de ser conhecido."
                                                    v-validate="'required'"
                                                    data-vv-name="artistic_name"
                                                    :error-messages="errors.collect('artistic_name')"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs6 md4 py-4>
                                                <v-select
                                                    v-model="artists[0].type"
                                                    :items="[
                                                            {name:'Solo',qtd_members:1,slug:'solo'},
                                                            {name:'Dupla',qtd_members:2,slug:'dupla'},
                                                            {name:'Banda',qtd_members:99,slug:'banda'},
                                                            {name:'Ministério',qtd_members:99,slug:'Ministério'}
                                                            ]"
                                                    item-text="name"
                                                    item-value="slug"
                                                    label="Tipo de artista"
                                                    messages="Escolha a opção que melhor defina o artista"                                                    
                                                ></v-select>
                                            </v-flex>

                                            <v-flex xs6 md4 py-4>
                                                <v-switch
                                                    :label="`Esse artista tem uma empresa ou é representado por uma empresa?`"
                                                    messages="Caso o artista tenha empresa é necessário marcar essa opção"
                                                    v-model="artists[0].is_company"                                                    
                                                ></v-switch>
                                            </v-flex>

                                            <!-- Artista possui empresa  -->
                                            <v-layout v-if="artists[0].is_company" px-3 wrap>
                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="Razão Social"
                                                        messages="Digite a Razão Social da Empresa"
                                                        v-model="artists[0].br_razao_social"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="Nome Fantasia"
                                                        messages="Digite o nome fantasia da empresa"
                                                        v-model="artists[0].br_nome_fantasia"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md4 lg4>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="CNPJ"
                                                        messages="Digite o CNPJ da Empresa"
                                                        v-mask="'##.###.###/####-##'"
                                                        v-model="artists[0].br_cnpj"
                                                    />
                                                </v-flex>
                                            </v-layout>


                                            <!-- Artista solo  -->
                                            <v-layout v-if="!artists[0].is_company && artists[0].type == 'solo'" px-3 wrap>
                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="Primeiro nome"
                                                        messages="Digite o seu primeiro nome"
                                                        v-model="artists[0].members[0].name"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="Sobrenome"
                                                        messages="Digite o seu sobrenome"
                                                        v-model="artists[0].members[0].lastname"
                                                    />
                                                </v-flex>

                                                <v-flex xs12 md4>
                                                    <v-text-field
                                                        class="purple-input"
                                                        label="CPF"
                                                        messages="Digite o seu CPF"
                                                        v-mask="'###.###.###-##'"
                                                        v-model="artists[0].members[0].cpf"
                                                    />
                                                </v-flex>
                                            </v-layout>

                                            <!-- Card Company -->
                                            <v-card elevation="0" v-if="artists[0].is_company || artists[0].type == 'solo'">
                                                <v-card-title style="color:#000">Dados Bancários</v-card-title>
                                                <v-card-text v-if="artists[0].is_company"
                                                >Entre com os dados bancários associados a empresa que foi adicionado no perfil artístico.</v-card-text>
                                                <v-card-text v-if="!artists[0].is_company"
                                                >Entre com os dados bancários associados ao seu CPF.</v-card-text>
                                                <v-card-text>                                                    
                                                    <v-layout wrap>
                                                        <v-flex xs12 md6>
                                                            <v-autocomplete
                                                                v-model="artists[0].bank_id"
                                                                :items="$store.getters.configs.banks"
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Banco"
                                                                messages="Digite o nome do Banco"
                                                            />
                                                        </v-flex>

                                                        <v-flex xs12 md3>
                                                            <v-text-field
                                                                class="purple-input"
                                                                label="Agência"
                                                                messages="Digite a agência sem digito verificador"
                                                                v-mask="'##########'"
                                                                v-model="artists[0].bank_agency"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md3>
                                                            <v-text-field
                                                                class="purple-input"
                                                                label="Conta"
                                                                messages="Digite a conta do seu banco com o digito verificador"
                                                                v-model="artists[0].bank_account"
                                                                v-mask="'###########'"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>

                                            <!-- Card solo -->
                                            <!-- <v-card elevation="0" v-if="!artists[0].is_company && artists[0].type == 'solo'">
                                                <v-card-title style="color:#000">Dados Bancários</v-card-title>
                                                <v-card-text
                                                >Entre com os dados bancários associados ao seu CPF.</v-card-text>
                                                <v-card-text>
                                                    <v-layout wrap>
                                                        <v-flex xs12 md6>
                                                            <v-autocomplete
                                                                v-model="artists[0].members[0].bank"
                                                                :items="$store.getters.configs.banks"
                                                                item-text="name"
                                                                item-value="id"
                                                                label="Banco"
                                                                messages="Digite o nome do Banco"
                                                            />
                                                        </v-flex>

                                                        <v-flex xs12 md3>
                                                            <v-text-field
                                                                class="purple-input"
                                                                label="Agência"
                                                                messages="Digite a agência sem digito verificador"
                                                                v-mask="'##########'"
                                                                v-model="artists[0].members[0].bank_agency"
                                                            />
                                                        </v-flex>
                                                        <v-flex xs12 md3>
                                                            <v-text-field
                                                                class="purple-input"
                                                                label="Conta"
                                                                messages="Digite a conta do seu banco com o digito verificador"
                                                                v-model="artists[0].members[0].bank_account"
                                                                v-mask="'###########'"
                                                            />
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card> -->

                                            <v-flex xs12 md12 style="background-color:#fcfcfc">
                                                <v-divider></v-divider>

                                                <template
                                                    v-if="artists[0].type != '' && artists[0].type != 'solo' && artists[0].is_company != 1"
                                                >
                                                    <form_persons
                                                        @persons_data="function(e){ artists[0].members = e; }"
                                                        :is_company="(artists[0].is_company ? 1:0)"
                                                        :personsdata="artists[0].members"
                                                        :artist_type="artists[0].type"
                                                    />
                                                </template>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                            <v-tab-item>
                                <v-card elevation="0">
                                    <v-card-title
                                        style="color:#000"
                                    >Suas informações como compositor</v-card-title>
                                    <v-card-text>
                                        <v-layout wrap>
                                            <v-flex xs12 md12>
                                                <v-text-field
                                                    label="Nome Compositor"
                                                    name="composer_name"
                                                    type="text"
                                                    v-model="composers[0].name"
                                                    hint="Nome pelo qual você é ou gostaria de ser conhecido."
                                                    v-validate="'required'"
                                                    data-vv-name="composer_name"
                                                    disabled
                                                    :error-messages="errors.collect('composer_name')"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>

                            <v-tab-item>
                                <v-card elevation="0">
                                    <v-card-title style="color:#000">Trocar Senha</v-card-title>
                                    <v-card-text>Altere a sua senha somente se você não se sentir segura com a atual.</v-card-text>
                                    <v-card-text>
                                        <v-layout wrap>
                                            <v-flex xs12>
                                                <v-divider></v-divider>
                                            </v-flex>

                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Senha"
                                                    name="pessoal_senha"
                                                    type="password"
                                                    v-model="person.password"
                                                    hint="Digite uma senha com no minimo de 8 caracteres entre letras e números."
                                                    autocomplete="new-password"
                                                    v-validate="'min:8'"
                                                    data-vv-name="password"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6>
                                                <v-text-field
                                                    label="Confirme a sua senha"
                                                    name="pessoal_senha_confirma"
                                                    type="password"
                                                    v-model="person.password_confirm"
                                                    hint="Digite novamente a sua senha."
                                                    autocomplete="new-password"
                                                    v-validate="'min:8'"
                                                    data-vv-name="password_confirm"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-tab-item>
                        </v-tabs>
                    </v-container>
                </v-card>
            </v-flex>
        </v-layout>
        <modalmessage ref="modalmessage" />
    </v-sheet>
</template>
<style>
.v-tabs-slider-wrapper + .v-tab {
    margin-left: auto !important;
}
.v-item-group {
    border-right: 1px solid #ddd !important;
}
</style>
<script>
import ProfileService from "../../app/Rest/profile";
import modalmessage from "../../components/shared/modalmessage";
import form_persons from "../../components/person/form_persons";
import Axios from "axios";

var profileService = null;

export default {
    components: {
        modalmessage,
        form_persons
    },
    data: () => ({
        opened_tab: 0,
        artists: [],
        person: {},
        message: {
            dialog_opened: false,
            title: "",
            message: "",
            btn_1_text: ""
        },
        estados_items: [
            { slug: "AC", name: "Acre" },
            { slug: "AL", name: "Alagoas" },
            { slug: "AP", name: "Amapá" },
            { slug: "AM", name: "Amazonas" },
            { slug: "BA", name: "Bahia" },
            { slug: "CE", name: "Ceará" },
            { slug: "DF", name: "Distrito Federal" },
            { slug: "ES", name: "Espírito Santo" },
            { slug: "GO", name: "Goiás" },
            { slug: "MA", name: "Maranhão" },
            { slug: "MT", name: "Mato Grosso" },
            { slug: "MS", name: "Mato Grosso do Sul" },
            { slug: "MG", name: "Minas Gerais" },
            { slug: "PA", name: "Pará" },
            { slug: "PB", name: "Paraíba" },
            { slug: "PR", name: "Paraná" },
            { slug: "PE", name: "Pernambuco" },
            { slug: "PI", name: "Piauí" },
            { slug: "RJ", name: "Rio de Janeiro" },
            { slug: "RN", name: "Rio Grande do Norte" },
            { slug: "RS", name: "Rio Grande do Sul" },
            { slug: "RO", name: "Rondônia" },
            { slug: "RR", name: "Roraima" },
            { slug: "SC", name: "Santa Catarina" },
            { slug: "SP", name: "São Paulo" },
            { slug: "SE", name: "Sergipe" },
            { slug: "TO", name: "Tocantins" }
        ],
        date: null,
        menu: false,
        person: {},
        model: 0,
        dictionary: {
            attributes: {
                email: "E-mail Address"
                // custom attributes
            },
            custom: {
                cpf: {
                    required: "O CPF é obrigatório."
                },
                dob: {
                    required: "A data de nascimento é obrigatório."
                },
                artistic_name: {
                    required: "O nome profissional é obrigatório."
                },
                first_name: {
                    required: "O primeiro nome é um campo obrigatório."
                },
                last_name: {
                    required: "Sobrenome é um campo obrigatório."
                },
                cellphone: {
                    required: "Celular é um campo obrigatório."
                },
                email: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                },
                email_confirm: {
                    required: "E-mail é um campo obrigatório.",
                    email: "Esse não parece um e-mail válido."
                },
                address_street: {
                    required: "O endereço é um campo obrigatório."
                },
                address_neighborhood: {
                    required: "O seu bairro é um campo obrigatório."
                },
                address_city: {
                    required: "A sua cidade é um campo obrigatório."
                },
                address_state: {
                    required: "O seu estado é um campo obrigatório."
                },
                address_zipcode: { required: "O CEP é um campo obrigatório." }
            }
        }
    }),
    watch: {
        menu(val) {
            val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
        },
        artists: {
            handler: function() {
                console.log("alterou artista");
            },
            deep: true
        },
        "person.address_zipcode": function() {
            if (!this.person.address_zipcode) {
                return;
            }
            if (
                this.person.address_zipcode.length == 9 &&
                !this.person.address_street
            ) {
                //consultar o cep

                Axios.get(
                    `https://viacep.com.br/ws/${this.person.address_zipcode}/json`
                ).then(e => {
                    //console.log(e);
                    if (typeof e.data == "object") {
                        //console.log('aqui vem');
                        this.person.address_street = e.data.logradouro;
                        this.person.address_neighborhood = e.data.bairro;
                        this.person.address_city = e.data.localidade;
                        this.person.address_state = e.data.uf;
                        this.$set(this.person);
                    }
                    //console.log(this.person)
                });
            }
        }
    },

    created() {
        //registerService = RegisterService.build();
        //console.log( );
        profileService = ProfileService.build();

        this.person = JSON.parse(
            JSON.stringify(this.$store.getters.user.myself)
        );
        this.artists = JSON.parse(
            JSON.stringify(this.$store.getters.user.artists)
        );
        this.composers = JSON.parse(
            JSON.stringify(this.$store.getters.user.composers)
        );

        if (this.artists[0].members == null || this.artists[0].members.length === 0) {
            this.artists[0].members = [];
            this.artists[0].members.push(this.$store.getters.user.myself);
            //console.log(this.$store.getters.user.myself);
        }
        //console.log("------");
        //console.log(this.artists[0].members);
    },
    mounted() {
        this.$validator.localize("pt_br", this.dictionary);
        this.date = this.person.dob;
        //direcionamos para a tab correta

        if (this.$route.params.tab) {
            this.opened_tab = this.$route.params.tab;
        }
        //this.cover = this.product.cover;
    },
    updated: function() {
        //this.email = "";
        //this.password = "";
    },
    computed: {
        enable_continue_button: function() {
            return this.$validator.validateAll();
        },
        formated_date: function() {
            return this.formatDate(this.date);
        }
    },
    methods: {
        // cleanCacheCompany (company) {
        //     if(company) {
        //         this.cleanCacheMembers()
        //     } else {
        //         this.artists[0].bank_account = ""
        //         this.artists[0].bank_agency = ""
        //         this.artists[0].bank_id = ""
        //         this.artists[0].br_cnpj = ""
        //         this.artists[0].br_nome_fantasia = ""
        //         this.artists[0].br_razao_social = ""
        //         this.artists[0].created_at = ""
        //     }
        // },
        // cleanCacheMembers () {
        //     if(this.artists[0].type == 'solo'){
        //         this.artists[0].members[0].bank = ""
        //         this.artists[0].members[0].bank_account = ""
        //         this.artists[0].members[0].bank_agency = ""
        //         this.artists[0].members[0].pivot.share = "100.00"
        //     }
        //     for(let i = 1; i < this.artists[0].members.length; i++){
        //         if(this.artists[0].members[i]) { 
        //             this.artists[0].members.splice(i, 1)
        //         } else {
        //             return
        //         }
        //     }
        // },
        salvar_info() {
            this.$validator.validateAll().then(is_valid => {
                if (!is_valid) {
                    return;
                }
                this.__salvar_info();
            });
        },
        __salvar_info() {
            this.$validator.reset();
            if (this.person.password) {
                if (this.person.password != this.person.password_confirm) {
                    this.$refs.modalmessage.show(
                        "Atenção aos campos!",
                        "Os campos de senha e confirme a sua senha estão diferentes.",
                        "Entendi"
                    );

                    return;
                }
            }

            var _person = JSON.parse(JSON.stringify(this.person));
            var _artists = JSON.parse(JSON.stringify(this.artists));
            var _composers = JSON.parse(JSON.stringify(this.composers));

            //verificamos os campos obrigatório para a empresa
            if (parseInt(_artists[0].is_company) == 1) {
                console.log("veio aqui");
                var erro = "";
                if (
                    _artists[0].br_nome_fantasia == undefined ||
                    _artists[0].br_nome_fantasia == ""
                ) {
                    erro = '"Nome Fantasia"';
                }
                if (
                    _artists[0].br_razao_social == undefined ||
                    _artists[0].br_razao_social == ""
                ) {
                    erro = '"Razão Social"';
                }
                if (
                    _artists[0].br_cnpj == undefined ||
                    _artists[0].br_cnpj == ""
                ) {
                    erro = '"CNPJ"';
                }
                if (erro != "") {
                    this.$refs.modalmessage.show(
                        "Atenção",
                        `O ${erro} é obrigatório quando a/o ${_artists[0].type} é representado por uma empresa!`,
                        "entendi"
                    );
                    this.opened_tab = 1;
                    return false;
                }
            }

            //fazemos as devidas validações
            if (_artists[0].type != "solo" && _artists[0].is_company != true) {
                if (_artists[0].members.length <= 1) {
                    this.$refs.modalmessage.show(
                        "Atenção",
                        `Você escolheu o tipo de artista <b> ${_artists[0].type}</b> logo é necessário ao menos 2 membros.`,
                        "entendi"
                    );
                    return;
                }

                var erro = false;
                var porcentagem = 0;
                _artists[0].members.filter(e => {
                    porcentagem += parseFloat(e.pivot.share);

                    if (e.name == undefined || e.name == "") {
                        erro = "nome";
                        return false;
                    }

                    if (e.lastname == undefined || e.lastname == "") {
                        erro = "sobrenome";
                        return false;
                    }

                    if (e.cpf == undefined || e.cpf == "") {
                        erro = "cpf";
                        return false;
                    }

                    //validar as contas se nao for empresa
                    if (parseInt(_artists[0].is_company) == 0) {
                        if (e.bank == undefined || e.bank == "") {
                            erro = "banco";
                            return false;
                        }

                        if (e.bank_agency == undefined || e.bank_agency == "") {
                            erro = "agência";
                            return false;
                        }

                        if (
                            e.bank_account == undefined ||
                            e.bank_account == ""
                        ) {
                            erro = "conta";
                            return false;
                        }
                    }
                });

                if (erro !== false) {
                    this.$refs.modalmessage.show(
                        "Atenção",
                        `O ${erro} é obrigatório para todos os membros!`,
                        "entendi"
                    );
                    this.opened_tab = 1;
                    return;
                }

                if (porcentagem != 100.0) {
                    this.opened_tab = 1;
                    this.$refs.modalmessage.show(
                        "Atenção",
                        `A soma das participações dos membros tem que ser exatos 100%!<br><br>A soma está em <b>${porcentagem}</b>.`,
                        "entendi"
                    );
                    return;
                }
            }

            this.$store.dispatch("loading_full");
            profileService
                .save({
                    person: _person,
                    artists: _artists,
                    composers: _composers
                })
                .then(e => {
                    if (e.status !== "error") {
                        this.$refs.modalmessage.show(
                            "Tudo certo",
                            "Seus dados foram salvos!",
                            "Entendi"
                        );

                        var user = JSON.parse(
                            JSON.stringify(this.$store.getters.user)
                        );
                        user.myself = e.items.person;
                        user.artists = e.items.artists;
                        console.log(user.myself);
                        this.$store.commit("user", user);
                        console.l;
                    } else {
                        this.$refs.modalmessage.show(
                            "Encontramos um problema",
                            e.msg,
                            "Entendi"
                        );
                    }
                })
                .finally(() => {
                    this.$store.dispatch("loading_full", false);
                });
        },
        data_nascimento_focado(e) {
            this.$refs.data_nascimento.$listeners.click(e);
        },
        continuar() {
            this.$validator.validateAll().then(isvalid => {
                if (!isvalid) {
                    return;
                }

                registerService.create(this.person).then(e => {
                    if (e.status == "ok") {
                        this.model = 1;
                        window.scrollTo(0, 0);
                    } else {
                        this.message.title = "Ops ...";
                        this.message.message = e.msg;
                        if (e.inl == "register_email_exist") {
                            this.message.btn_2_text = "RECUPERAR SENHA";
                        }
                        this.message.dialog_opened = true;
                    }
                });
            });
        },
        saveDate(date) {
            this.person.dob = date;
            this.$refs.menu.save(this.formatDate(date));
        },
        formatDate(date) {
            if (!date) return null;

            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;

            const [month, day, year] = date.split("/");
            return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
    }
};
</script>
